import {makeObservable, observable} from 'mobx';

import type {Nullable} from '../../../utils/utility-types';
import type {DateTimeModel} from '../Date/DateTime.model';
import type {SubtenantModel} from '../Subtenant/Subtenant.model';

import {BaseModel} from '../Base/Base.model';

const ModelName = 'TenantModel';

export class TenantModel extends BaseModel {
  clientId: string;
  created: DateTimeModel;
  notificationUrl: Nullable<string>;
  reporting: boolean;
  subtenants: SubtenantModel[];
  templateFolder: string;
  title: string;
  updated: DateTimeModel;

  constructor(props: TenantModel.Props) {
    super(props);
    Object.assign(this, props);

    makeObservable(
      this,
      BaseModel.mobxAnnotationFactory<TenantModel, TenantModel.Props>(props, {
        subtenants: observable.shallow,
      }),
    );
  }

  static override get modelName(): typeof ModelName {
    return ModelName;
  }

  get modelName(): typeof ModelName {
    return ModelName;
  }
}

export namespace TenantModel {
  export type Props = BaseModel.ModelToProps<TenantModel>;
}
